import React, { Component } from "react";

// bootstrap
import { Spinner, Button, Form } from "react-bootstrap";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExcelIcon from "../../../assets/excel-icon.svg";
import DisabledEcxelIcon from "../../../assets/disabled-excel.svg";
import WordEcxelIcon from "../../../assets/word-excel.svg";

/// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";

// actions
import {
  getDownloadWeeklyReportAction,
  clearWeeklyReportReportAction,
  getDownloadUserDetails,
  clearUserDetailsReportAction,
  getDownloadIssueWithCommentsReportsAction,
  clearIssueWithCommentAction,
  getDownloadDecisionReportsAction,
  clearDecissionAction,
  getDownloadMinistryStateIssueReport,
  clearMinistryStateIssueReportAction
} from "../../../actions/dowloadExcelActions";

import { getGroupsByCategoryAction } from "../../../actions/createProject.action";
import { LoaderPage } from "../../../component/Loader";

class DownloadReports extends Component {
  state = { ministryList: [], ministry: null };

  componentDidMount() {
    this.getMinistryList();
  }

  getMinistryList = async () => {
    const { getGroupsByCategoryActionDispatch } = this.props;

    let response;
    response = await getGroupsByCategoryActionDispatch(undefined, {
      category: ["STATE"]
    });
    if (response) {
      const { data, status } = response;
      if (status) {
        this.setState({
          ministryList: data
        });
      } else {
        this.setState({ ministryList: [] });
      }
    }
  };

  onClickingStatusDropDown() {
    const { ministryList } = this.state;
    const ministryListOption = [];
    ministryList.map(ministryList => {
      ministryListOption.push({
        name: "ministryList",
        label: ministryList.name,
        value: ministryList.id
      });
    });
    return ministryListOption;
  }

  onChange = value => {
    this.setState({ ministry: value });
  };

  onMinistrySelect = async getDataDispatcher => {
    await getDataDispatcher();
    this.setState({ ministry: null });
  };

  render() {
    const {
      props: {
        decissionReducer,
        weeklyReportReducer,
        issueWithCommentsReducer,
        userDetailReportsReducer,
        ministryStateIssueReportReducer,
        getDownloadWeeklyReportDispatch,
        clearWeeklyReportReportDispatch,
        getDownloadUserDetailsDispatch,
        clearUserDetailsReportDispatch,
        getDownloadIssueWithCommentsReportsDispatch,
        clearIssueWithCommentDispatch,
        getDownloadDecisionReportsDispatch,
        clearDecissionDispatch,
        getDownloadMinistryStateIssueReportDispatch,
        clearMinistryStateIssueReportDispatch
      },
      state: { ministryList, ministry }
    } = this;
    const isMinistryListLoaded = this.state.ministryList.length > 0;
    return (
      <div className="download_reports_container">
        <LoaderPage loading={!isMinistryListLoaded} />
        <h3 className="header report-header">Reports</h3>
        {[
          {
            ...weeklyReportReducer,
            getDataDispatcher: getDownloadWeeklyReportDispatch,
            clearDispatcher: clearWeeklyReportReportDispatch
          },
          {
            ...userDetailReportsReducer,
            getDataDispatcher: getDownloadUserDetailsDispatch,
            clearDispatcher: clearUserDetailsReportDispatch
          },
          {
            ...issueWithCommentsReducer,
            getDataDispatcher: getDownloadIssueWithCommentsReportsDispatch,
            clearDispatcher: clearIssueWithCommentDispatch
          },
          {
            ...decissionReducer,
            getDataDispatcher: getDownloadDecisionReportsDispatch,
            clearDispatcher: clearDecissionDispatch
          },
          {
            ...ministryStateIssueReportReducer,
            getDataDispatcher: getDownloadMinistryStateIssueReportDispatch,
            clearDispatcher: clearMinistryStateIssueReportDispatch,
            callForMinistry: true
          }
        ]
          .filter(value => value.show)
          .map(value => {
            return value.show ? (
              <div key={value.title} className="download_reports">
                <span>{value.title || "Downloading"}</span>
                <section className="field-align">
                  {value.title === "Ministry/State Issue Report" && (
                    <Select
                      placeholder="-Select Ministry/State- "
                      options={this.onClickingStatusDropDown()}
                      value={ministry || " "}
                      onChange={event => this.onChange(event)}
                      isMulti={false}
                      isClearable={true}
                      classNamePrefix="react-select-inDownloadreport"
                      disabled={value.isLoading}
                    />
                  )}
                  {value.isLoading ? (
                    <div>
                      <div className="downloading_from_server">
                        <span className="download-icons-excel" />
                        <Spinner
                          as="span"
                          animation="border"
                          size="2x"
                          role="status"
                          aria-hidden="true"
                        />
                      </div>
                    </div>
                  ) : (
                    <React.Fragment />
                  )}
                  {value.downloadingSrc ? (
                    <div className="download_icon_section download_file_icon">
                      <div className="download_link">
                        <Button variant="" size="sm">
                          <a
                            className="download_icon"
                            onClick={() => {
                              this.onMinistrySelect(value.clearDispatcher);
                            }}
                            href={value.downloadingSrc}
                            download
                          >
                            <FontAwesomeIcon icon={faDownload} size="2x" />
                          </a>
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment />
                  )}
                  {!value.downloadingSrc && !value.isLoading ? (
                    <div className="download_icon_section">
                      {value.title === "PMG Report" ? (
                        <div className="word-excel d-flex align-center justify-content-center">
                          <img
                            src={WordEcxelIcon}
                            variant="outline-info"
                            size="2x"
                            onClick={() => {
                              value &&
                                value.getDataDispatcher &&
                                value.getDataDispatcher(undefined, ministry);
                            }}
                          />
                        </div>
                      ) : value.title === "Ministry/State Issue Report" ? (
                        ministry == null || ministry === "" ? (
                          <div className="disabled-excel d-flex align-center justify-content-center">
                            <img
                              src={DisabledEcxelIcon}
                              variant="outline-info"
                              size="sm"
                              onClick={() => {
                                value &&
                                  value.getDataDispatcher &&
                                  value.getDataDispatcher(undefined, ministry);
                              }}
                            />
                          </div>
                        ) : (
                          <div className="word-excel d-flex align-center justify-content-center">
                            <img
                              src={WordEcxelIcon}
                              variant="outline-info"
                              size="sm"
                              onClick={() => {
                                value &&
                                  value.getDataDispatcher &&
                                  value.getDataDispatcher(
                                    undefined,
                                    ministry.value
                                  );
                              }}
                            />
                          </div>
                        )
                      ) : (
                        <div className="excel d-flex align-center justify-content-center">
                          <img
                            src={ExcelIcon}
                            variant="outline-info"
                            size="sm"
                            onClick={() => {
                              value &&
                                value.getDataDispatcher &&
                                value.getDataDispatcher(undefined, ministry);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <React.Fragment />
                  )}
                </section>
              </div>
            ) : (
              <React.Fragment />
            );
          })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    weeklyReportReducer: state.donwloadExcelReducer.weeklyReport,
    userDetailReportsReducer: state.donwloadExcelReducer.userDetailReports,
    issueWithCommentsReducer: state.donwloadExcelReducer.issueWithComments,
    decissionReducer: state.donwloadExcelReducer.decission,
    ministryStateIssueReportReducer:
      state.donwloadExcelReducer.ministryStateIssueReport
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDownloadWeeklyReportDispatch: getDownloadWeeklyReportAction,
      clearWeeklyReportReportDispatch: clearWeeklyReportReportAction,
      getDownloadUserDetailsDispatch: getDownloadUserDetails,
      clearUserDetailsReportDispatch: clearUserDetailsReportAction,
      clearMinistryStateIssueReportDispatch: clearMinistryStateIssueReportAction,
      getDownloadMinistryStateIssueReportDispatch: getDownloadMinistryStateIssueReport,
      getDownloadIssueWithCommentsReportsDispatch: getDownloadIssueWithCommentsReportsAction,
      clearIssueWithCommentDispatch: clearIssueWithCommentAction,
      getDownloadDecisionReportsDispatch: getDownloadDecisionReportsAction,
      clearDecissionDispatch: clearDecissionAction,
      getGroupsByCategoryActionDispatch: getGroupsByCategoryAction
    },
    dispatch
  );
}

const DownloadReportsComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadReports);
export { DownloadReportsComponent };
